import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  AppBar,
  Toolbar,

  IconButton,

} from "@mui/material";
import { motion,AnimatePresence } from "framer-motion";
import { GlobalStyles } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";


const Marketing3 = () => {

const [activeIndex, setActiveIndex] = useState(0);
const [openAdmission, setOpenAdmission] = useState(false);
const [openTransport, setOpenTransport] = useState(false);


const [selectedMenu, setSelectedMenu] = useState("Home");

const menuContent = {
  Home: {
    title: "Start Better Learning Future From Here",
    subtitle: "EXCELLENCE IN EDUCATION",
    description:
      "Empowering students with academic excellence and holistic development.",
    image: "https://images.unsplash.com/photo-1588072432836-e10032774350",
  },
  About: {
    title: "About EduVibe School",
    subtitle: "OUR MISSION & VISION",
    description:
      "Providing world-class education in a safe and disciplined environment.",
    image: "https://images.unsplash.com/photo-1577896851231-70ef18881754",
  },
  Courses: {
    title: "Explore Our Courses",
    subtitle: "LEARN & GROW",
    description: "Wide range of courses designed for every student.",
    image: "https://images.unsplash.com/photo-1584697964403-b44b6d92c3b9",
  },
  Pages: {
    title: "More About EduVibe",
    subtitle: "DISCOVER OUR SCHOOL",
    description: "Get to know our campus, faculty, and achievements.",
    image: "https://images.unsplash.com/photo-1588072432836-e10032774350",
  },
  Blog: {
    title: "Latest News & Articles",
    subtitle: "INSIGHTS & TIPS",
    description: "Stay updated with our education tips and blog posts.",
    image: "https://images.unsplash.com/photo-1523050854058-8df90110c9f1",
  },
  Shop: {
    title: "EduVibe Merchandise",
    subtitle: "OUR PRODUCTS",
    description: "Shop school merchandise and learning materials online.",
    image: "https://images.unsplash.com/photo-1577896851231-70ef18881754",
  },
};


useEffect(() => {
  const interval = setInterval(() => {
    setActiveIndex((prev) => (prev + 1) % slides.length);
  }, 4000);

  return () => clearInterval(interval);
}, []);


    const slides = [
  {
    title: "Start Better Learning Future From Here",
    subtitle: "EXCELLENCE IN EDUCATION",
    description:
      "Empowering students with academic excellence and holistic development.",
    image:
      "https://images.unsplash.com/photo-1588072432836-e10032774350",
    tag: "School Program",
    cardTitle: "Smart Learning Environment",
    cardDesc: "Modern classrooms & expert faculty",
  },
  {
    title: "Safe & Reliable Transport Facilities",
    subtitle: "STUDENT SAFETY FIRST",
    description:
      "GPS-enabled buses with trained drivers and attendants.",
    image:
      "https://images.unsplash.com/photo-1577896851231-70ef18881754",
    tag: "Transport",
    cardTitle: "School Transport",
    cardDesc: "Safe routes with real-time tracking",
  },
];

const Header = () => {
  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #eee",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* LEFT LOGO */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            component="img"
            src="https://dummyimage.com/40x40/4c5cff/ffffff&text=🎓"
            alt="EduVibe"
            sx={{ width: 40, height: 40 }}
          />
          <Box sx={{ fontSize: "22px", fontWeight: 700, color: "#4c5cff" }}>
            EduVibe
          </Box>
        </Box>

        {/* CENTER MENU */}
<Box sx={{ display: { xs: "none", md: "flex" }, gap: 4 }}>
  {["Home", "About", "Courses", "Pages", "Blog", "Shop"].map((item) => (
    <Box
      key={item}
      sx={{
        display: "flex",
        alignItems: "center",
        fontWeight: 500,
        color: selectedMenu === item ? "#4c5cff" : "#1f2343",
        cursor: "pointer",
      }}
      onClick={() => setSelectedMenu(item)}
    >
      {item}
      <KeyboardArrowDownIcon fontSize="small" />
    </Box>
  ))}
</Box>


        {/* RIGHT ACTIONS */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <IconButton>
            <SearchIcon />
          </IconButton>

          <Button
            variant="contained"
            sx={{
              backgroundColor: "#4c5cff",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              borderRadius: "8px",
            }}
          >
            Login / Register
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};



  return (
    
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop: "60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <>
         <Header />
<CardContent sx={{ p: 0 }}>

  {/* GLOBAL STYLES */}
  <GlobalStyles
    styles={{
      body: {
        backgroundColor: "#f8f9fc",
        fontFamily: "'Poppins', sans-serif",
      },
      "@media (max-width:600px)": {
        ".MuiButton-root": {
          width: "100%",
          marginBottom: "12px",
        },
      },
    }}
  />

  {/* ================= HERO SECTION ================= */}
  <Box sx={{ px: { xs: 2, md: 6 }, py: 8 }}>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1.2fr 1fr" },
        gap: 5,
        alignItems: "center",
      }}
    >
      <Box>
       <Box sx={{ color: "#4c5cff", fontWeight: 600 }}>
  {menuContent[selectedMenu].subtitle}
</Box>

<Box
  sx={{
    fontSize: { xs: 32, md: 52 },
    fontWeight: 800,
    color: "#1f2343",
    my: 2,
  }}
>
  {menuContent[selectedMenu].title}
</Box>

<Box sx={{ color: "#555", maxWidth: 520, mb: 4 }}>
  {menuContent[selectedMenu].description}
</Box>


        <Button
          variant="contained"
          sx={{
            backgroundColor: "#4c5cff",
            px: 4,
            py: 1.5,
            borderRadius: "10px",
            fontWeight: 600,
            mr: 2,
          }}
          onClick={() => setOpenAdmission(true)}
        >
          Apply for Admission →
        </Button>

        <Button
          variant="outlined"
          sx={{
            borderColor: "#4c5cff",
            color: "#4c5cff",
            px: 4,
            py: 1.5,
            borderRadius: "10px",
            fontWeight: 600,
          }}
          onClick={() => setOpenTransport(true)}
        >
          Transport Enquiry
        </Button>
      </Box>

      <Box>
         <Box
        component="img"
        src={menuContent[selectedMenu].image}
        sx={{
          width: "100%",
          borderRadius: "20px",
          boxShadow: "0 30px 60px rgba(0,0,0,0.15)",
        }}
      />
    </Box>
    </Box>
  </Box>

  {/* ================= TESTIMONIALS ================= */}
  <Box sx={{ py: 8, backgroundColor: "#f8f9fc" }}>
    <Box sx={{ textAlign: "center", mb: 5 }}>
      <Box sx={{ color: "#4c5cff", fontWeight: 600 }}>TESTIMONIALS</Box>
      <Box sx={{ fontSize: { xs: 28, md: 40 }, fontWeight: 800 }}>
        What Parents Say
      </Box>
    </Box>

    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
        gap: 4,
        maxWidth: 1200,
        mx: "auto",
        px: 2,
      }}
    >
      {[
        "Excellent academics and disciplined environment.",
        "Safe transport and very caring teachers.",
        "Modern classrooms and good communication with parents.",
      ].map((text, i) => (
        <Card key={i} sx={{ p: 3, borderRadius: "16px" }}>
          <Box sx={{ color: "#555", mb: 2 }}>
            “{text}”
          </Box>
          <Box sx={{ fontWeight: 700 }}>Parent</Box>
        </Card>
      ))}
    </Box>
  </Box>

  {/* ================= GALLERY ================= */}
  <Box sx={{ py: 8 }}>
    <Box sx={{ textAlign: "center", mb: 5 }}>
      <Box sx={{ color: "#4c5cff", fontWeight: 600 }}>GALLERY</Box>
      <Box sx={{ fontSize: { xs: 28, md: 40 }, fontWeight: 800 }}>
        Campus Life
      </Box>
    </Box>

    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(4,1fr)" },
        gap: 2,
        maxWidth: 1200,
        mx: "auto",
        px: 2,
      }}
    >
      {[
        "https://images.unsplash.com/photo-1523050854058-8df90110c9f1",
        "https://images.unsplash.com/photo-1577896851231-70ef18881754",
        "https://images.unsplash.com/photo-1584697964403-b44b6d92c3b9",
        "https://images.unsplash.com/photo-1588072432836-e10032774350",
      ].map((img, i) => (
        <Box
          key={i}
          component="img"
          src={img}
          sx={{
            width: "100%",
            height: { xs: 140, md: 200 },
            objectFit: "cover",
            borderRadius: "14px",
          }}
        />
      ))}
    </Box>
  </Box>

  {/* ================= FOOTER ================= */}
  <Box sx={{ backgroundColor: "#1f2343", color: "#fff", pt: 6 }}>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "2fr 1fr 1fr 1fr" },
        gap: 4,
        maxWidth: 1200,
        mx: "auto",
        px: 3,
      }}
    >
      <Box>
        <Box sx={{ fontSize: 22, fontWeight: 800 }}>EduVibe School</Box>
        <Box sx={{ color: "#ccc", mt: 1, fontSize: 14 }}>
          Excellence in education with values and discipline.
        </Box>
      </Box>

      <Box>
        <Box sx={{ fontWeight: 700 }}>Quick Links</Box>
        {["Home", "About", "Admissions", "Contact"].map((i) => (
          <Box key={i} sx={{ color: "#ccc", fontSize: 14, mt: 0.5 }}>
            {i}
          </Box>
        ))}
      </Box>

      <Box>
        <Box sx={{ fontWeight: 700 }}>Academics</Box>
        {["Courses", "Faculty", "Events"].map((i) => (
          <Box key={i} sx={{ color: "#ccc", fontSize: 14, mt: 0.5 }}>
            {i}
          </Box>
        ))}
      </Box>

      <Box>
        <Box sx={{ fontWeight: 700 }}>Contact</Box>
        <Box sx={{ fontSize: 14, color: "#ccc", mt: 1 }}>
          📍 Bhongir, Telangana <br />
          📞 +91 98765 43210 <br />
          ✉ info@school.com
        </Box>
      </Box>
    </Box>

    <Box
      sx={{
        borderTop: "1px solid rgba(255,255,255,0.1)",
        mt: 4,
        py: 2,
        textAlign: "center",
        fontSize: 13,
        color: "#aaa",
      }}
    >
      © {new Date().getFullYear()} EduVibe School. All rights reserved.
    </Box>
  </Box>

</CardContent>


</>

{/* Admission Enquiry Popup */}
<Dialog open={openAdmission} onClose={() => setOpenAdmission(false)} maxWidth="sm" fullWidth>
  <DialogTitle>Admission Enquiry</DialogTitle>
  <DialogContent>
    <TextField fullWidth margin="dense" label="Student Name" />
    <TextField fullWidth margin="dense" label="Parent Name" />
    <TextField fullWidth margin="dense" label="Class Applying For" />
    <TextField fullWidth margin="dense" label="Mobile Number" />
    <TextField fullWidth margin="dense" label="Email" />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenAdmission(false)}>Cancel</Button>
    <Button variant="contained">Submit</Button>
  </DialogActions>
</Dialog>

{/* Transport Enquiry Popup */}
<Dialog open={openTransport} onClose={() => setOpenTransport(false)} maxWidth="sm" fullWidth>
  <DialogTitle>Transport Enquiry</DialogTitle>
  <DialogContent>
    <TextField fullWidth margin="dense" label="Student Name" />
    <TextField fullWidth margin="dense" label="Pickup Location" />
    <TextField fullWidth margin="dense" label="Class" />
    <TextField fullWidth margin="dense" label="Parent Mobile Number" />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setOpenTransport(false)}>Cancel</Button>
    <Button variant="contained">Submit</Button>
  </DialogActions>
</Dialog>



      </Card>
    </Box>
  );
};

export default Marketing3;